import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { CANCELLED, } from '../logic/common/state'

type Refresh = () => void

interface CancelStatusItemReservationParams {
  hashItemReserve: string
  nameReserve: string
  refresh: Refresh
  notify: any
  setLoadingCancelStatusItem: React.Dispatch<React.SetStateAction<boolean>>
  setNameReserve: React.Dispatch<React.SetStateAction<string>>
  setHashItemReserve: React.Dispatch<React.SetStateAction<string>>
  setConfirmCancelStatus: React.Dispatch<React.SetStateAction<boolean>> | undefined
  setOpenCancelStatusModal: React.Dispatch<React.SetStateAction<boolean>> | undefined
}

export const cancelStatusItemReservation = async ({
  hashItemReserve,
  nameReserve,
  refresh,
  notify,
  setLoadingCancelStatusItem,
  setNameReserve,
  setHashItemReserve,
  setConfirmCancelStatus,
  setOpenCancelStatusModal,
}: CancelStatusItemReservationParams): Promise<void> => {
  try {
    setLoadingCancelStatusItem(true)
    setOpenCancelStatusModal && setOpenCancelStatusModal(false)
    const response = await itemServices.cancel_status_item(hashItemReserve)
    if (response?.status === CANCELLED || !response) {
      notify('ra.notification.cancel_status_item_success', {
        type: 'success',
        messageArgs: { item: nameReserve },
      })
      setNameReserve('')
      setHashItemReserve('')
      setConfirmCancelStatus && setConfirmCancelStatus(false)
      setLoadingCancelStatusItem(false)
      return
    }
    setNameReserve('')
    setHashItemReserve('')
    setConfirmCancelStatus && setConfirmCancelStatus(false)
    setLoadingCancelStatusItem(false)
    notify('ra.notification.cancel_status_item_error', {
      type: 'error',
      messageArgs: { item: nameReserve },
    })
  } catch (error) {
    notify('ra.notification.cancel_status_item_error', {
      type: 'error',
      messageArgs: { item: nameReserve },
    })
    setNameReserve('')
    setHashItemReserve('')
    setLoadingCancelStatusItem(false)
    setConfirmCancelStatus && setConfirmCancelStatus(false)
    setOpenCancelStatusModal && setOpenCancelStatusModal(false)
  } finally {
    customAwait([refresh])
  }
}
